<template>
  <pt-withdraw-table class="pt-withdraw-table__withData"   @getWithdrawList="getWithdrawList" :tableLabels="tableLabels" :page-size="page_size"
  :tableData="tableData" :totalNumber="totalNumber" ref="table" v-loading="loading"   @select="select" @selectAll="selectAll" :data="balance"
  :selectedAmount="selectedAmount" :noWithdrawalsAmountShow="noWithdrawalsAmountShow" :withdrawAmountOfNo="withdrawAmountOfNo">
    <slot/>
  </pt-withdraw-table>
</template>

<script>
import PtWithdrawTable from './index'
import { cashCount } from '@/utils/formUtils'
export default {
  name: 'pt-withdraw-table__withData',
  components: {
    'pt-withdraw-table': PtWithdrawTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isSearch: {
      type: String
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    selectedAmount: {
      type: [String, Number]
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      totalNumber: 0,
      page_size: this.pageSize,
      tableData: [],
      sign: 0,
      isOutside: false,
      loading: false,
      balance: {},
      noWithdrawalsAmountShow: null,
      withdrawAmountOfNo: null
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.resetPage()
        } else {
          this.isOutside = true
          this.getWithdrawList(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    // “未提现金额总计”(生命银行中全部已发放奖励金额总计 - 生命银行中已提现（已完成提现的+待审核提现的）)
    noWithdrawalsAmount () {
      this.loading = true
      this.$store.dispatch('noWithdrawalsAmount').then(res => {
        this.loading = false
        this.withdrawAmountOfNo = res
        this.noWithdrawalsAmountShow = res && cashCount(res, true, 2)
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取未提现金额失败')
      })
    },
    queryMerchantBalance () {
      this.loading = true
      // this.$store.dispatch('getUserBalance').then(res => {
      this.$store.dispatch('queryMerchantBalance').then(res => {
        this.loading = false
        this.balance = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取提现账户余额失败')
        // this.$message.error(err || '获取商户余额失败')
      })
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    // 获取提现审核的列表
    getWithdrawList (page, next, size) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: this.page,
          size: size || this.page_size,
          sort: 'createdDate,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getWithdrawalsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取意见反馈列表失败')
      })
    }
  },
  created () {
    this.queryMerchantBalance()
    this.noWithdrawalsAmount()
  }
}
</script>
